// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Sortable from "@stimulus-components/sortable"
application.register("sortable", Sortable)

import Notification from "@stimulus-components/notification"
application.register("notification", Notification)

import CheckboxSelectAll from "@stimulus-components/checkbox-select-all"
application.register("checkbox-select-all", CheckboxSelectAll)

import Dialog from "./dialog_controller"
application.register("dialog", Dialog)

import SelectController from "./select_controller"
application.register("select", SelectController)

import BatchActionsController from "./batch_actions_controller"
application.register("batch-actions", BatchActionsController)

import CopyFeedbackController from "./copy_feedback_controller"
application.register("copy-feedback", CopyFeedbackController)

import Clipboard from "@stimulus-components/clipboard"
application.register("clipboard", Clipboard)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import PerPageController from "./per_page_controller"
application.register("per-page", PerPageController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import DoubleClickEditController from "./double_click_edit_controller"
application.register("double-click-edit", DoubleClickEditController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import Chart from "stimulus-chartjs"
application.register("chart", Chart)

import QuickFillController from "./quick_fill_controller"
application.register("quick-fill", QuickFillController)

import FocusController from "./focus_controller"
application.register("focus", FocusController)
